<script setup lang="ts">
import { computed } from 'vue';
import SimulateInput from './SimulateInput.vue';
import type CalculationResult from '@/lib/calculator/result';
import type { Fleet } from '@/lib/trashsim/fleet';
import type { Settings } from '@/lib/trashsim/settings';

const props = defineProps<{
    modelValue: Fleet
    settings: Settings
    result?: CalculationResult | null
}>()

const emits = defineEmits<{
    (e: 'update:modelValue', value: Fleet): void
    (e: 'submit'): void
}>()

const defender = computed({
    get: () => props.modelValue,
    set: (value: Fleet) => emits('update:modelValue', value)
})
const submit = () => emits('submit')
</script>

<template>
    <div id="planet-column" class="inner-column">
        <div class="content">
            <div id="ipm-simulate"></div>
            <h3>{{ $t('home.planet.title') }}</h3>
            <div id="defender-0-defence">
                <h4>{{ $t('home.planet.resources.label') }}</h4>
                <!-- TODO use icons for resources, saves space -->
                <div class="clearfix">
                    <!-- <ResourceInput v-for="resource in ResourceMembers" v-model="defender.resources[resource]" /> -->
                    <div class="planet-resource">
                        <label>
                            <span class="labels-text">{{ $t('home.planet.resources.metal') }}</span>
                            <input type="number" v-model="defender.resources.metal" />
                        </label>
                    </div>
                    <div class="planet-resource">
                        <label>
                            <span class="labels-text">{{ $t('home.planet.resources.crystal') }}</span>
                            <input type="number" v-model="defender.resources.crystal" />
                        </label>
                    </div>
                    <div class="planet-resource">
                        <label>
                            <span class="labels-text">{{ $t('home.planet.resources.deuterium') }}</span>
                            <input type="number" v-model="defender.resources.deuterium" />
                        </label>
                    </div>
                    <div class="planet-resource">
                        <label>
                            <span class="labels-text">Food:</span>
                            <input type="number" v-model="defender.resources.food" />
                        </label>
                    </div>
                </div>
                <!-- TODO add the result for the remaining def -->
                <h4>{{ $t('home.planet.defence') }}</h4>
                <ul class="simulate-values">
                    <li class="clearfix" v-for="(_, type) in defender.defenses">
                        <SimulateInput
                            v-model="defender.defenses[type].amount"
                            :booster="defender.defenses[type]"
                            :label="$t(`type.${type}`)"
                            :type="(type == 407 || type == 408) ? 'checkbox' : 'number'"
                            :result="result && defender.defenses[type] ? result?.entitiesRemaining.defenders[0][type] || 0 : null"
                            :true-value=1
                            @submit="submit"
                        />
                    </li>
                    <li class="clearfix" v-for="(type) in [212, 217]">
                        <SimulateInput v-model="defender.ships[type]" :label="$t(`type.${type}`)" />
                    </li>
                    <li class="clearfix">
                        <SimulateInput v-model="defender.engineer" :label="$t('home.planet.engineer')" type="checkbox" />
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<style scoped>
.planet-resource {
    width: 24% !important;
    margin: 0 0.5% !important;
}
</style>